import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M7 14l5-5 5 5z" />, 'ArrowDropUp');
